import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { AdminModule } from "../../services/admin-access.service";

export interface TeamMember {
  id: number;
  name: string;
  email: string;
  mobile: string;
  isActive: boolean;
  isSuper: boolean;
  modules: string[];
  pending: boolean;
  createdAt: string;
}

@Injectable({ providedIn: "root" })
export class RolesService {
  private base = environment.baseUrl + "admin/team";

  constructor(private http: HttpClient) {}

  modules(): Observable<AdminModule[]> {
    return this.http.get<AdminModule[]>(this.base + "/modules");
  }

  list(): Observable<TeamMember[]> {
    return this.http.get<TeamMember[]>(this.base);
  }

  create(body: { name: string; email: string; mobile: string; modules: string[]; isSuper: boolean }) {
    return this.http.post<{ status: string; id: number; emailed: boolean }>(this.base, body);
  }

  update(id: number, body: { name?: string; mobile?: string; modules?: string[]; isSuper?: boolean }) {
    return this.http.patch<{ status: string }>(this.base + "/" + id, body);
  }

  setActive(id: number, isActive: boolean) {
    return this.http.post<{ status: string }>(this.base + "/" + id + "/status", { isActive });
  }

  resendInvite(id: number) {
    return this.http.post<{ status: string; email: string }>(this.base + "/" + id + "/resend-invite", {});
  }

  remove(id: number) {
    return this.http.delete<{ status: string }>(this.base + "/" + id);
  }
}
